module.exports = __webpack_public_path__ + "static/media/importFlybook4.8ef3f33c.png";